//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction, httpAction } from '@/api/manage';
import EquipmentControlLogList from "./EquipmentControlLogList";
import EquipmentControlLogModal from "./EquipmentControlLogModal";
export default {
  name: 'CarDetailedList',
  mixins: [JeecgListMixin],
  components: {
    EquipmentControlLogList: EquipmentControlLogList,
    EquipmentControlLogModal: EquipmentControlLogModal
  },
  data: function data() {
    return {
      pageTitle: '设备详细',
      deviceData: {},
      loginUser: '',
      assetId: '',
      scopeId: '',
      deviceStatus: '',
      deviceStatusMessage: '',
      autoLoadInit: false,
      url: {
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view',
        queryEquipmentControl: '/ea/asset/info/queryEquipmentControl/',
        add: '/online/equipment/control/log'
      }
    };
  },
  created: function created() {
    this.loginUser = this.$store.getters.userInfo.id;
    this.assetId = this.$route.query.assetId;
    this.scopeId = this.$route.query.scopeId;

    if (this.assetId == null) {
      this.returnDetailed();
    } else {
      this.loadDeviceData();
      this.loadData();
    }
  },
  computed: {},
  methods: {
    loadDeviceData: function loadDeviceData() {
      var that = this;
      that.deviceData = {};
      getAction(this.url.queryEquipmentControl + this.assetId).then(function (res) {
        if (res.success) {
          that.deviceData = res.result;
          that.deviceData.photo = that.getImageView(that.deviceData.photo); // var reg = RegExp(/,/).test(that.deviceData.coding)
          // if (reg.test(that.deviceData.coding)) {
          //   that.deviceData.coding = that.deviceData.coding.split(',')
          // } else {
          //   that.deviceData.coding = []
          // }
          // var e = that.deviceData.coding.includes('i12011')
        }
      });
      var params = {
        assetId: this.assetId,
        scopeId: this.scopeId
      };
      getAction('/online/deviceOnlineStatus', params).then(function (res) {
        if (res.success) {
          if (res.result.length > 0) {
            that.deviceStatus = res.result[0].deviceStatus;
            that.deviceStatusMessage = res.result[0].deviceStatusMessage;
          }
        }
      });
    },
    getImageView: function getImageView(photo) {
      return this.url.imgerver + '/' + photo;
    },
    returnDetailed: function returnDetailed() {
      this.$router.push({
        path: '/monitor/EquipmentControl'
      });
    },
    handleAdd: function handleAdd(coding) {
      this.deviceData.infoId = coding;
      this.$refs.modalForm.add(this.deviceData);
      this.$refs.modalForm.title = '设备控制';
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
    },
    handleOk: function handleOk(coding, info) {
      var that = this; // 触发表单验证

      var httpurl = '';
      var method = '';
      var formData = this.deviceData;
      formData.siteId = this.deviceData.siteId;
      formData.assetId = this.deviceData.id;
      formData.userId = this.loginUser;

      if (this.deviceData.factorId != null && this.deviceData.coding != null) {
        formData.polId = this.deviceData.factorId;
        formData.infoId = coding;
        formData.info = info;
        httpurl += this.url.add;
        method = 'post';
        httpAction("/comm/api/equipmentControlRpc", formData, method).then(function (res) {
          if (res.success) {
            that.$message.success(res.message);
            that.$emit('ok');
          } else {
            that.$message.warning(res.message);
          }
        });
      } else {
        that.$message.warning('现场端控制编码或设备信息编码为空');
      }
    }
  }
};